<template>
  <el-popover
    ref="popover"
    :show-arrow="false" trigger="hover"
    :popper-class="['c-header-popper', 'header-website-popper', theme || injectTheme || routeTheme]" placement="bottom-start" :popper-style="{width: 'auto'}"
    @show="showAssets = true"
    @hide="showAssets = false"
  >
    <template #reference>
      <div
        class="flex items-center py-4px px-10px rd-4px bg-[rgba(0,0,0,0.05)] c-black cursor-pointer text-sm-r dark:bg-[rgba(255,255,255,0.05)] dark:c-[--gray-25]"
        :class="{ '!c-[--primary-500]': showAssets }"
      >
        {{ $t('香港站-home') }}
        <base-icon
          name="menu-down"
          class="ml-6px text-8px transition-transform duration-300"
          :class="{ 'rotate-180': showAssets }"
        />
      </div>
    </template>
    <div class="site-warp p-12px">
      <template v-for="(item, index) in siteList" :key="index">
        <div
          class="py-16px px-8px rd-8px c-[--gray-700] cursor-pointer hover:bg-[--gray-50] dark:c-[--gray-25] dark:hover:bg-[rgba(255,255,255,0.04)]"
          @click="switchSite(item.link, item.text)"
        >
          <div
            class="text-sm-m"
            :class="{ '!c-[--primary-500]': item.link === 'hk' }"
          >
            {{ item.text }}
          </div>
          <!-- <div class="mt-4px c-[--gray-400] text-xs-r">
            {{ item.desc }}
          </div> -->
        </div>
      </template>
    </div>
  </el-popover>
</template>

<script setup lang="ts">
import { linkToGlobalSite } from '@/utils/tools';
import BaseIcon from '@c/common/Icon.vue';
const popover = ref();
const showAssets = ref(false);
defineProps({
  theme: {
    type: String,
    default: ''
  }
});

const injectTheme = inject('theme');
const router = useRouter();
const route = useRoute();
const routeTheme = computed(() => {
  const routeProps: any = route.meta.props;
  return routeProps?.header?.theme;
});

const { t } = useI18n();

const siteList = computed(() => {
  return [
    { link: 'hk', text: t('香港站-home'), desc: t('home_website_hk_desc') },
    { link: 'gb', text: t('国际站-home'), desc: t('home_website_global_desc') }
  ];
});

const switchSite = (url:string, text:string) => {
  if (url === 'hk') {
    // 自动隐藏
    popover.value.hide();
  } else {
    linkToGlobalSite();
  }
};

</script>